import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor() {
  }

  getInvoices() {
    return ['Invoice1', 'Invoice2', 'Invoice3'];
  }
}
